import React from "react";
import { PageBuilderAccordionTextFragment } from "types/graphql-types";
import { graphql } from "gatsby";
import PageBuilderSectionTitle from "./PageBuilderSectionTitle";
import AccordionText from "components/AccordionText/AccordionText";
import { ComponentBackgroundColor } from "types/componentBackground";
import { AccordionTextItemType } from "components/AccordionText/AccordionTextItem";
import { isPresent } from "src/utils/checks";

export interface PageBuilderAccordionTextProps
  extends PageBuilderAccordionTextFragment {
  backgroundColor?: ComponentBackgroundColor;
}

const PageBuilderAccordionText: React.FC<PageBuilderAccordionTextProps> = ({
  heading,
  items = [],
  backgroundColor
}) => {
  const localizedItems = (items || [])
    .map<AccordionTextItemType | null>((i) => {
      if (!i) return null;
      const title = i.title?.localized;
      if (!title) return null;

      return {
        ...i,
        _key: i._key || title,
        title: title,
        content: i.content?.localized
      };
    })
    .filter(isPresent);

  return (
    <React.Fragment>
      <PageBuilderSectionTitle {...heading} />
      {localizedItems.length > 0 && (
        <AccordionText
          items={localizedItems}
          backgroundColor={backgroundColor}
        />
      )}
    </React.Fragment>
  );
};

export default PageBuilderAccordionText;

export const fragments = graphql`
  fragment PageBuilderAccordionText on SanityAccordionText {
    _key
    heading {
      ...SectionTitle
      ...SectionTitleCTAs
    }

    items {
      _key
      title {
        localized
      }

      content {
        localized
      }
    }
  }
`;
